import { FeatureData } from "views/components/Schedules/components/UpdateActivityPopup/styles";

const GroupRoomContent = ({
    id, name,
    capacity,
    screen, pavilion,
    floor, environment
}) => {
    return (
        <FeatureData>
            <p>
                <b>{name} ({id})</b>
                <br/>
                Cantidad máxima de alumnos: {capacity}
                <br/>
                Pantalla: {screen}
                <br/>
                Ambiente: {environment} / {pavilion} Piso: {floor}
            </p>
        </FeatureData>
    );
}

export default GroupRoomContent;